// extracted by mini-css-extract-plugin
export default {"card":"WelcomeHero_card__couAx","avatar":"WelcomeHero_avatar__fpbWg","content":"WelcomeHero_content__sg4fu","hello":"WelcomeHero_hello__Av1BI"};